define('views/components/timeline/timeline_blocks',['require','backbone','views/components/timeline/timeline_block','marionette','text!templates/components/timeline/timeline_blocks.html'],function(require){

    var Backbone = require('backbone');
    var ChildView = require('views/components/timeline/timeline_block');
    require('marionette');
    var temp = require("text!templates/components/timeline/timeline_blocks.html");
    


    return Backbone.Marionette.CompositeView.extend({
        template: _.template(temp),
        tagName: 'div',
        className: "timeline-container top circle",
        childViewContainer: '.timeline',
        childView: ChildView,


        initialize: function () {
            this.selectedProduct = {};
            //this.listenTo(this.collection, 'fetch_complete', this._onFetch);
            //this.collection.fetch();
            this.on('render', this.afterRender);

        },
        afterRender: function(){
           
        },
        ui: function(){
            return{
                block : ".timeline"
            };
        },
        
        events: {
        },
        _onFetch: function () {
            this.render();
        },

        
        
    });
});

